import TeamList from '../components/team/TeamList';
import { useApp } from '../context/AppContext';
import TaskModal from '../components/task/TaskModal';

import { PageTitle } from '../../../../_metronic/layout/core';

export default function TeamsPage() {
  const { state, dispatch } = useApp();
  const selectedTask = state.tasks.find(t => t.id === state.selectedTaskId);

  return (
    <>
      <PageTitle>DevOps - Gerenciamento de Equipes</PageTitle>
      <TeamList />
      {selectedTask && (
        <TaskModal
          task={selectedTask}
          onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
        />
      )}
    </>
  );
}
